<template>
  <div class="team-schedule-page nx-list-page">
    <div class="team-schedule-shell el-card">
      <div class="schedule-search el-card">
        <div class="el-card__body">
          <div class="calendar-search">
            <el-form :inline="true" :model="query" size="small" class="calendar-search-form">
              <el-form-item label="排班日期">
                <el-date-picker v-model="query.scheduleDateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
              </el-form-item>
              <el-form-item label="班组">
                <el-select v-model="query.teamNo" clearable filterable placeholder="请选择" @change="onTeamChange">
                  <el-option v-for="item in teamOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                </el-select>
              </el-form-item>
              <el-form-item label="班次">
                <el-select v-model="query.shiftNo" clearable placeholder="请选择">
                  <el-option v-for="item in shiftOptions" :key="item.shiftNo" :label="item.shiftName" :value="item.shiftNo" />
                </el-select>
              </el-form-item>
              <el-form-item label="状态">
                <el-select v-model="query.scheduleStatus" clearable placeholder="请选择">
                  <el-option label="生效" :value="1" />
                  <el-option label="停用" :value="0" />
                </el-select>
              </el-form-item>
              <el-form-item class="calendar-search-actions">
                <el-button type="primary" size="small" icon="el-icon-search" @click="searchSchedule">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetSchedule">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="schedule-toolbar">
        <div class="team-schedule-menu-left">
          <el-radio-group v-model="viewMode" size="small" class="view-switch" @change="handleViewModeChange">
            <el-radio-button label="calendar"><i class="el-icon-date" />日历视图</el-radio-button>
            <el-radio-button label="list"><i class="el-icon-tickets" />列表视图</el-radio-button>
          </el-radio-group>
          <el-tag size="small">共 {{ page.total }} 条排班</el-tag>
        </div>
        <div class="team-schedule-menu-right">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="openSchedule()">新增排班</el-button>
          <el-button type="success" size="small" @click="openBatch">批量排班</el-button>
          <el-button size="small" @click="copyVisible = true">复制排班</el-button>
          <el-button size="small" @click="openShiftDialog">班次配置</el-button>
          <el-button type="warning" size="small" icon="el-icon-download" :loading="exportLoading" @click="exportPdf">导出 PDF</el-button>
        </div>
      </div>
      <div class="schedule-content el-card">
        <div class="el-card__body schedule-content-body">
          <div v-if="viewMode === 'calendar'" v-loading="loading" class="calendar-grid">
            <div v-for="day in calendarDays" :key="day.date" class="day-card">
              <div class="day-head">
                <strong>{{ day.date }}</strong>
                <span>{{ day.week }}</span>
              </div>
              <div v-if="day.items.length" class="schedule-list">
                <div v-for="item in day.items" :key="item.id" class="schedule-item" @click="openSchedule(item)">
                  <strong class="team-name">{{ item.teamName }}</strong>
                  <div class="shift-name">{{ item.shiftName }}</div>
                  <div class="schedule-time"><i class="el-icon-time" />{{ item.startTime }}-{{ item.endTime }}</div>
                  <div class="members"><i class="el-icon-user" />{{ item.memberNames || "-" }}</div>
                </div>
              </div>
              <el-empty v-else description="暂无排班" :image-size="42" />
            </div>
          </div>
          <div v-else class="schedule-list-view">
            <el-table ref="scheduleTable" v-loading="loading" class="schedule-table" :data="data" stripe height="100%">
              <el-table-column prop="scheduleDate" label="日期" min-width="110" />
              <el-table-column prop="teamName" label="班组" min-width="140" />
              <el-table-column prop="shiftName" label="班次" min-width="110" />
              <el-table-column label="时间段" min-width="130">
                <template slot-scope="{ row }">{{ row.startTime }}-{{ row.endTime }}</template>
              </el-table-column>
              <el-table-column prop="principalName" label="负责人" min-width="130" />
              <el-table-column prop="memberNames" label="排班人员" min-width="220" show-overflow-tooltip />
              <el-table-column prop="scheduleStatus" label="状态" min-width="90">
                <template slot-scope="{ row }">
                  <el-tag size="small">{{ row.scheduleStatus === 1 ? "生效" : "停用" }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="{ row }">
                  <div class="table-actions">
                    <el-button type="text" size="small" @click="openSchedule(row)">编辑</el-button>
                    <el-button type="text" size="small" @click="removeRow(row)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="schedule-pagination">
              <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :current-page.sync="page.currentPage"
                :page-size.sync="page.pageSize"
                :total="page.total"
                @current-change="currentChange"
                @size-change="sizeChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="scheduleForm.id ? '编辑排班' : '新增排班'" :visible.sync="scheduleVisible" width="640px" append-to-body top="7vh">
      <el-form ref="scheduleForm" :model="scheduleForm" :rules="scheduleRules" label-width="100px">
        <el-form-item label="排班日期" prop="scheduleDate"><el-date-picker v-model="scheduleForm.scheduleDate" type="date" value-format="yyyy-MM-dd" /></el-form-item>
        <el-form-item label="班组" prop="teamNo">
          <el-select v-model="scheduleForm.teamNo" filterable @change="onFormTeamChange">
            <el-option v-for="item in teamOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
          </el-select>
        </el-form-item>
        <el-form-item label="班次" prop="shiftNo">
          <el-select v-model="scheduleForm.shiftNo" @change="onFormShiftChange">
            <el-option v-for="item in formShiftOptions" :key="item.shiftNo" :label="item.shiftName" :value="item.shiftNo" />
          </el-select>
        </el-form-item>
        <el-form-item label="时间段"><el-input :value="scheduleForm.startTime && scheduleForm.endTime ? scheduleForm.startTime + '-' + scheduleForm.endTime : ''" disabled /></el-form-item>
        <el-form-item label="排班人员" prop="memberIds">
          <el-select v-model="scheduleForm.memberIds" multiple filterable>
            <el-option v-for="item in memberOptions" :key="item.memberId" :label="item.memberName" :value="item.memberId" />
          </el-select>
        </el-form-item>
        <el-form-item label="负责人">
          <el-select v-model="scheduleForm.principalIds" multiple filterable>
            <el-option v-for="item in selectedMemberOptions" :key="item.memberId" :label="item.memberName" :value="item.memberId" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态"><el-switch v-model="scheduleForm.enabled" active-text="生效" inactive-text="停用" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="scheduleForm.remark" type="textarea" :rows="3" maxlength="500" show-word-limit /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="scheduleVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="submitSchedule">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量排班" :visible.sync="batchVisible" width="640px" append-to-body top="7vh">
      <el-form ref="batchForm" :model="batchForm" :rules="batchRules" label-width="100px">
        <el-form-item label="排班日期段" prop="dateRange">
          <el-date-picker v-model="batchForm.dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
        </el-form-item>
        <el-form-item label="班组" prop="teamNo">
          <el-select v-model="batchForm.teamNo" filterable @change="onBatchTeamChange">
            <el-option v-for="item in teamOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
          </el-select>
        </el-form-item>
        <el-form-item label="班次" prop="shiftNo">
          <el-select v-model="batchForm.shiftNo" @change="onBatchShiftChange">
            <el-option v-for="item in batchShiftOptions" :key="item.shiftNo" :label="item.shiftName" :value="item.shiftNo" />
          </el-select>
        </el-form-item>
        <el-form-item label="时间段">
          <el-input :value="batchForm.startTime && batchForm.endTime ? batchForm.startTime + '-' + batchForm.endTime : ''" disabled />
        </el-form-item>
        <el-form-item label="排班人员" prop="memberIds">
          <el-select v-model="batchForm.memberIds" multiple filterable>
            <el-option v-for="item in batchMemberOptions" :key="item.memberId" :label="item.memberName" :value="item.memberId" />
          </el-select>
        </el-form-item>
        <el-form-item label="负责人">
          <el-select v-model="batchForm.principalIds" multiple filterable>
            <el-option v-for="item in selectedBatchMemberOptions" :key="item.memberId" :label="item.memberName" :value="item.memberId" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="batchForm.enabled" active-text="生效" inactive-text="停用" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="batchForm.remark" type="textarea" :rows="3" maxlength="500" show-word-limit />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="batchVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="submitBatch">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="班次配置" :visible.sync="shiftVisible" width="760px" append-to-body top="7vh">
      <div class="shift-toolbar">
        <el-select v-model="shiftQueryTeamNo" placeholder="选择班组" @change="loadShiftPage">
          <el-option v-for="item in teamOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
        </el-select>
        <el-button type="primary" size="small" @click="openShiftForm()">新增班次</el-button>
      </div>
      <el-table :data="shiftTable" border>
        <el-table-column prop="teamName" label="班组" />
        <el-table-column prop="shiftNo" label="班次编码" />
        <el-table-column prop="shiftName" label="班次名称" />
        <el-table-column label="时间段"><template slot-scope="{ row }">{{ row.startTime }}-{{ row.endTime }}</template></el-table-column>
        <el-table-column prop="sort" label="排序" width="80" />
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openShiftForm(row)">编辑</el-button>
            <el-button type="text" size="small" @click="deleteShift(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :title="shiftForm.id ? '编辑班次' : '新增班次'" :visible.sync="shiftFormVisible" width="480px" append-to-body top="7vh">
      <el-form :model="shiftForm" label-width="100px">
        <el-form-item label="班组"><el-select v-model="shiftForm.teamNo" @change="onShiftTeamChange"><el-option v-for="item in teamOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" /></el-select></el-form-item>
        <el-form-item label="班次编码"><el-input v-model="shiftForm.shiftNo" /></el-form-item>
        <el-form-item label="班次名称"><el-input v-model="shiftForm.shiftName" /></el-form-item>
        <el-form-item label="开始时间"><el-time-picker v-model="shiftForm.startTime" value-format="HH:mm:ss" /></el-form-item>
        <el-form-item label="结束时间"><el-time-picker v-model="shiftForm.endTime" value-format="HH:mm:ss" /></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="shiftForm.sort" :min="0" /></el-form-item>
      </el-form>
      <div slot="footer"><el-button size="small" @click="shiftFormVisible = false">取消</el-button><el-button type="primary" size="small" @click="submitShift">保存</el-button></div>
    </el-dialog>

    <el-dialog title="复制排班" :visible.sync="copyVisible" width="420px" append-to-body top="7vh">
      <el-form :model="copyForm" label-width="100px">
        <el-form-item label="来源日期"><el-date-picker v-model="copyForm.sourceDate" value-format="yyyy-MM-dd" /></el-form-item>
        <el-form-item label="目标日期"><el-date-picker v-model="copyForm.targetDate" value-format="yyyy-MM-dd" /></el-form-item>
        <el-form-item label="班组"><el-select v-model="copyForm.teamNo" clearable><el-option v-for="item in teamOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" /></el-select></el-form-item>
      </el-form>
      <div slot="footer"><el-button size="small" @click="copyVisible = false">取消</el-button><el-button type="primary" size="small" @click="submitCopy">复制</el-button></div>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import {
  getSchedulePage,
  getCalendar,
  saveSchedule,
  updateSchedule,
  removeSchedule,
  batchSaveSchedule,
  copySchedule,
  exportSchedulePdf,
  getShiftPage,
  getShiftListByTeam,
  saveShift,
  updateShift,
  removeShift,
  getTeamDict,
  getTeamPage,
} from "./api";

function ymd(date) {
  const d = date || new Date();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
}

function addDays(base, n) {
  const d = new Date(base.getTime());
  d.setDate(d.getDate() + n);
  return d;
}

function daysBetween(startDate, endDate) {
  const start = new Date(startDate);
  const end = new Date(endDate);
  return Math.floor((end - start) / 86400000) + 1;
}

function downloadPdf(blobData, filename) {
  const blob = blobData instanceof Blob ? blobData : new Blob([blobData], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export default {
  name: "TeamSchedule",
  mixins: [crudMixins],
  data() {
    const today = new Date();
    return {
      apiConfig: { getList: getSchedulePage },
      viewMode: "calendar",
      exportLoading: false,
      teamOptions: [],
      shiftOptions: [],
      formShiftOptions: [],
      memberOptions: [],
      scheduleVisible: false,
      scheduleForm: {},
      batchVisible: false,
      batchForm: {},
      batchShiftOptions: [],
      batchMemberOptions: [],
      scheduleRules: {
        scheduleDate: [{ required: true, message: "请选择排班日期", trigger: "change" }],
        teamNo: [{ required: true, message: "请选择班组", trigger: "change" }],
        shiftNo: [{ required: true, message: "请选择班次", trigger: "change" }],
        memberIds: [{ required: true, type: "array", message: "请选择排班人员", trigger: "change" }],
      },
      batchRules: {
        dateRange: [{ required: true, type: "array", message: "请选择排班日期段", trigger: "change" }],
        teamNo: [{ required: true, message: "请选择班组", trigger: "change" }],
        shiftNo: [{ required: true, message: "请选择班次", trigger: "change" }],
        memberIds: [{ required: true, type: "array", message: "请选择排班人员", trigger: "change" }],
      },
      shiftVisible: false,
      shiftQueryTeamNo: "",
      shiftTable: [],
      shiftFormVisible: false,
      shiftForm: {},
      copyVisible: false,
      copyForm: {},
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        columnBtn: false,
        refreshBtn: false,
        searchShowBtn: false,
        searchMenuSpanSuper: 24,
        searchSize: "small",
        menuWidth: 130,
        column: [
          {
            label: "排班日期",
            prop: "scheduleDateRange",
            type: "daterange",
            search: true,
            hide: true,
            searchValue: [ymd(today), ymd(addDays(today, 30))],
            paramsKey: ["startDate", "endDate"],
            searchSpan: 6,
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
          },
          {
            label: "班组",
            prop: "teamNo",
            type: "select",
            search: true,
            hide: true,
            dicData: [],
            props: { label: "dictValue", value: "dictKey" },
            searchSpan: 6,
            change: ({ value }) => this.onTeamChange(value),
          },
          {
            label: "班次",
            prop: "shiftNo",
            type: "select",
            search: true,
            hide: true,
            dicData: [],
            props: { label: "shiftName", value: "shiftNo" },
            searchSpan: 6,
          },
          { label: "日期", prop: "scheduleDate", minWidth: 110 },
          { label: "班组", prop: "teamName", minWidth: 140 },
          { label: "班次", prop: "shiftName", minWidth: 110 },
          { label: "时间段", prop: "timeRange", minWidth: 130, slot: true },
          { label: "负责人", prop: "principalName", minWidth: 130 },
          { label: "排班人员", prop: "memberNames", minWidth: 220, overHidden: true },
          {
            label: "状态",
            prop: "scheduleStatus",
            type: "select",
            search: true,
            minWidth: 90,
            slot: true,
            dicData: [
              { label: "生效", value: 1 },
              { label: "停用", value: 0 },
            ],
            searchSpan: 6,
          },
        ],
      },
    };
  },
  computed: {
    currentDateRange() {
      const range = this.query.scheduleDateRange || [];
      return range.length ? range : this.getDefaultDateRange();
    },
    calendarDays() {
      const start = new Date(this.currentDateRange[0] || ymd(new Date()));
      const map = {};
      this.data.forEach((item) => {
        if (!map[item.scheduleDate]) map[item.scheduleDate] = [];
        map[item.scheduleDate].push(item);
      });
      const length = Math.max(1, Math.min(daysBetween(this.currentDateRange[0], this.currentDateRange[1]), 31));
      return Array.from({ length }).map((_, i) => {
        const date = ymd(addDays(start, i));
        return { date, week: ["日", "一", "二", "三", "四", "五", "六"][addDays(start, i).getDay()], items: map[date] || [] };
      });
    },
    selectedMemberOptions() {
      const ids = this.scheduleForm.memberIds || [];
      return this.memberOptions.filter((item) => ids.indexOf(String(item.memberId)) > -1);
    },
    selectedBatchMemberOptions() {
      const ids = this.batchForm.memberIds || [];
      return this.batchMemberOptions.filter((item) => ids.indexOf(String(item.memberId)) > -1);
    },
  },
  mounted() {
    this.initOptions();
    this.refreshSchedule();
  },
  methods: {
    getDefaultDateRange() {
      const today = new Date();
      return [ymd(today), ymd(addDays(today, 30))];
    },
    getColumn(prop) {
      return (this.option.column || []).find((item) => item.prop === prop) || {};
    },
    refreshSchedule() {
      this.onLoad(this.page, this.query);
    },
    initOptions() {
      getTeamDict().then((res) => {
        this.teamOptions = res.data.data || [];
        this.$set(this.getColumn("teamNo"), "dicData", this.teamOptions);
      });
    },
    buildParams() {
      const params = this.formatParams(Object.assign({}, this.defaultParams, this.query));
      return {
        ...params,
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
    },
    onLoad(page, params = {}) {
      this.queryData = this.formatParams(Object.assign({}, this.defaultParams, params, this.query));
      const requestParams = {
        ...this.queryData,
        page: page.currentPage,
        size: page.pageSize,
      };
      this.loading = true;
      const request = this.viewMode === "calendar" ? getCalendar : getSchedulePage;
      return request(requestParams).then((res) => {
        if (this.viewMode === "calendar") {
          this.data = res.data.data || [];
          this.page.total = this.data.length;
          return;
        }
        const data = res.data.data || {};
        this.data = data.records || [];
        this.page.total = data.total || 0;
      }).finally(() => {
        this.loading = false;
        this.$nextTick(() => {
          this.$refs.scheduleTable && this.$refs.scheduleTable.doLayout();
        });
      });
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.selectionClear();
      this.onLoad(this.page, params);
      done && done();
    },
    searchReset() {
      this.query = {};
      this.shiftOptions = [];
      this.$set(this.getColumn("shiftNo"), "dicData", []);
      this.initSearchValue();
      this.selectionClear();
      this.page.currentPage = 1;
      this.onLoad(this.page, this.query);
    },
    searchSchedule() {
      this.page.currentPage = 1;
      this.refreshSchedule();
    },
    resetSchedule() {
      this.query = {};
      this.shiftOptions = [];
      this.$set(this.getColumn("shiftNo"), "dicData", []);
      this.initSearchValue();
      this.page.currentPage = 1;
      this.refreshSchedule();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.refreshSchedule();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.currentPage = 1;
      this.refreshSchedule();
    },
    handleViewModeChange() {
      this.page.currentPage = 1;
      this.refreshSchedule();
    },
    onTeamChange(teamNo) {
      this.query.shiftNo = "";
      if (!teamNo) {
        this.shiftOptions = [];
        this.$set(this.getColumn("shiftNo"), "dicData", []);
        return;
      }
      getShiftListByTeam(teamNo).then((res) => {
        this.shiftOptions = res.data.data || [];
        this.$set(this.getColumn("shiftNo"), "dicData", this.shiftOptions);
      });
    },
    openSchedule(row) {
      this.scheduleForm = row ? this.normalizeScheduleForm(row) : { scheduleDate: this.currentDateRange[0], enabled: true, memberIds: [], principalIds: [] };
      this.formShiftOptions = [];
      this.memberOptions = [];
      if (this.scheduleForm.teamNo) this.onFormTeamChange(this.scheduleForm.teamNo, !row);
      this.scheduleVisible = true;
    },
    openBatch() {
      this.batchForm = {
        dateRange: [].concat(this.currentDateRange),
        enabled: true,
        memberIds: [],
        principalIds: [],
      };
      this.batchShiftOptions = [];
      this.batchMemberOptions = [];
      this.batchVisible = true;
    },
    normalizeScheduleForm(row) {
      const memberList = row.memberList || [];
      return {
        ...row,
        enabled: row.scheduleStatus !== 0,
        memberIds: memberList.map((m) => String(m.memberId)),
        principalIds: memberList.filter((m) => m.roleType === 2).map((m) => String(m.memberId)),
      };
    },
    onFormTeamChange(teamNo, resetFields = true) {
      const team = this.teamOptions.find((item) => item.dictKey === teamNo);
      this.$set(this.scheduleForm, "teamName", team ? team.dictValue : "");
      if (resetFields) {
        this.$set(this.scheduleForm, "shiftNo", "");
        this.$set(this.scheduleForm, "shiftName", "");
        this.$set(this.scheduleForm, "startTime", "");
        this.$set(this.scheduleForm, "endTime", "");
        this.$set(this.scheduleForm, "memberIds", []);
        this.$set(this.scheduleForm, "principalIds", []);
      }
      getShiftListByTeam(teamNo).then((res) => { this.formShiftOptions = res.data.data || []; });
      getTeamPage({ teamNo, page: 1, size: 1 }).then((res) => {
        const row = ((res.data.data || {}).records || [])[0] || {};
        const ids = String(row.memberIds || "").split(",").filter(Boolean);
        const names = String(row.memberNames || "").split(",").filter(Boolean);
        this.memberOptions = ids.map((id, index) => ({ memberId: String(id), memberName: names[index] || id }));
      });
    },
    onBatchTeamChange(teamNo) {
      const team = this.teamOptions.find((item) => item.dictKey === teamNo);
      this.$set(this.batchForm, "teamName", team ? team.dictValue : "");
      this.$set(this.batchForm, "shiftNo", "");
      this.$set(this.batchForm, "shiftName", "");
      this.$set(this.batchForm, "startTime", "");
      this.$set(this.batchForm, "endTime", "");
      this.$set(this.batchForm, "memberIds", []);
      this.$set(this.batchForm, "principalIds", []);
      this.batchShiftOptions = [];
      this.batchMemberOptions = [];
      getShiftListByTeam(teamNo).then((res) => {
        this.batchShiftOptions = res.data.data || [];
      });
      getTeamPage({ teamNo, page: 1, size: 1 }).then((res) => {
        const row = ((res.data.data || {}).records || [])[0] || {};
        const ids = String(row.memberIds || "").split(",").filter(Boolean);
        const names = String(row.memberNames || "").split(",").filter(Boolean);
        this.batchMemberOptions = ids.map((id, index) => ({ memberId: String(id), memberName: names[index] || id }));
      });
    },
    onFormShiftChange(shiftNo) {
      const shift = this.formShiftOptions.find((item) => item.shiftNo === shiftNo);
      if (!shift) return;
      this.scheduleForm.shiftName = shift.shiftName;
      this.scheduleForm.startTime = shift.startTime;
      this.scheduleForm.endTime = shift.endTime;
    },
    onBatchShiftChange(shiftNo) {
      const shift = this.batchShiftOptions.find((item) => item.shiftNo === shiftNo);
      if (!shift) return;
      this.batchForm.shiftName = shift.shiftName;
      this.batchForm.startTime = shift.startTime;
      this.batchForm.endTime = shift.endTime;
    },
    submitSchedule() {
      this.$refs.scheduleForm.validate((valid) => {
        if (!valid) return;
        const principalIds = this.scheduleForm.principalIds || [];
        const memberList = (this.scheduleForm.memberIds || []).map((id) => {
          const memberId = String(id);
          const member = this.memberOptions.find((item) => String(item.memberId) === memberId) || {};
          return { memberId, memberName: member.memberName, roleType: principalIds.indexOf(memberId) > -1 ? 2 : 1 };
        });
        const data = { ...this.scheduleForm, scheduleStatus: this.scheduleForm.enabled ? 1 : 0, memberList };
        const request = data.id ? updateSchedule : saveSchedule;
        request(data).then(() => {
          this.$message.success("保存成功");
          this.scheduleVisible = false;
          this.refreshSchedule();
        });
      });
    },
    submitBatch() {
      this.$refs.batchForm.validate((valid) => {
        if (!valid) return;
        const range = this.batchForm.dateRange || [];
        const days = this.buildDateList(range[0], range[1]);
        if (days.length > 31) {
          this.$message.warning("批量排班日期范围不能超过31天");
          return;
        }
        const principalIds = this.batchForm.principalIds || [];
        const memberList = (this.batchForm.memberIds || []).map((id) => {
          const memberId = String(id);
          const member = this.batchMemberOptions.find((item) => String(item.memberId) === memberId) || {};
          return { memberId, memberName: member.memberName, roleType: principalIds.indexOf(memberId) > -1 ? 2 : 1 };
        });
        const scheduleList = days.map((date) => ({
          scheduleDate: date,
          teamNo: this.batchForm.teamNo,
          teamName: this.batchForm.teamName,
          shiftNo: this.batchForm.shiftNo,
          shiftName: this.batchForm.shiftName,
          startTime: this.batchForm.startTime,
          endTime: this.batchForm.endTime,
          scheduleStatus: this.batchForm.enabled ? 1 : 0,
          remark: this.batchForm.remark,
          memberList,
        }));
        batchSaveSchedule({ scheduleList }).then(() => {
          this.$message.success("批量排班保存成功");
          this.batchVisible = false;
          this.refreshSchedule();
        });
      });
    },
    buildDateList(startDate, endDate) {
      const list = [];
      const start = new Date(startDate);
      const end = new Date(endDate);
      for (let d = start; d <= end; d = addDays(d, 1)) {
        list.push(ymd(d));
      }
      return list;
    },
    removeRow(row) {
      this.$confirm("确认删除该排班？").then(() => {
        removeSchedule(row.id).then(() => {
          this.$message.success("删除成功");
          this.refreshSchedule();
        });
      });
    },
    openShiftDialog() {
      this.shiftVisible = true;
      if (!this.shiftQueryTeamNo && this.teamOptions.length) this.shiftQueryTeamNo = this.teamOptions[0].dictKey;
      this.loadShiftPage();
    },
    loadShiftPage() {
      getShiftPage({ teamNo: this.shiftQueryTeamNo, page: 1, size: 100 }).then((res) => {
        this.shiftTable = (res.data.data || {}).records || [];
      });
    },
    openShiftForm(row) {
      this.shiftForm = row ? { ...row } : { teamNo: this.shiftQueryTeamNo, sort: 0, status: 1 };
      this.onShiftTeamChange(this.shiftForm.teamNo);
      this.shiftFormVisible = true;
    },
    onShiftTeamChange(teamNo) {
      const team = this.teamOptions.find((item) => item.dictKey === teamNo);
      this.shiftForm.teamName = team ? team.dictValue : "";
    },
    submitShift() {
      const request = this.shiftForm.id ? updateShift : saveShift;
      request(this.shiftForm).then(() => {
        this.$message.success("保存成功");
        this.shiftFormVisible = false;
        this.loadShiftPage();
      });
    },
    deleteShift(row) {
      this.$confirm("确认删除该班次？").then(() => {
        removeShift(row.id).then(() => {
          this.$message.success("删除成功");
          this.loadShiftPage();
        });
      });
    },
    submitCopy() {
      copySchedule(this.copyForm).then(() => {
        this.$message.success("复制成功");
        this.copyVisible = false;
        this.refreshSchedule();
      });
    },
    async exportPdf() {
      this.exportLoading = true;
      try {
        const res = await exportSchedulePdf(this.buildParams());
        downloadPdf(res.data || res, `produce排班表_${Date.now()}.pdf`);
        this.$message.success("导出成功");
      } catch (e) {
        this.$message.error((e && e.message) || "导出失败");
      } finally {
        this.exportLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.team-schedule-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  padding: 0;

  .team-schedule-shell {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    border: none;
    box-shadow: none;
    overflow: hidden;
  }

  .schedule-search {
    flex-shrink: 0;
    border: none;
    background-color: #fff;

    > .el-card__body {
      padding: 12px 16px 10px;
      box-sizing: border-box;
    }
  }

  .team-schedule-menu-left,
  .team-schedule-menu-right,
  .day-head,
  .shift-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .team-schedule-menu-left,
  .team-schedule-menu-right {
    flex-wrap: wrap;
  }

  .team-schedule-menu-right {
    gap: 8px;
  }

  .team-schedule-menu-right .el-button + .el-button {
    margin-left: 0;
  }

  ::v-deep .el-button--small {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    padding: 8px 15px;
    line-height: 14px;
    vertical-align: middle;
  }

  ::v-deep .el-button--small [class^="el-icon-"],
  ::v-deep .el-button--small [class*=" el-icon-"] {
    font-size: 14px;
    line-height: 1;
  }

  ::v-deep .el-button--small [class*="el-icon-"] + span {
    margin-left: 5px;
  }

  .calendar-search {
    padding: 10px 5px 7px 0;
    background: #f0f7ff;
    box-sizing: border-box;
  }

  .calendar-search-form {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 7px 0;

    .el-form-item {
      width: 25%;
      padding-right: 8px;
      margin-right: 0;
      margin-bottom: 0;
      box-sizing: border-box;
    }

    .calendar-search-actions {
      width: 100%;
      text-align: right;
    }

    ::v-deep .el-form-item__label {
      width: 110px;
      padding-right: 12px;
      box-sizing: border-box;
    }

    ::v-deep .el-form-item__content {
      width: calc(100% - 110px);
    }

    ::v-deep .el-date-editor,
    ::v-deep .el-select {
      width: 100%;
    }
  }

  .schedule-toolbar {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    padding: 6px 16px 8px;
    border-bottom: 1px solid #ebeef5;
    background-color: #fff;
    box-sizing: border-box;
  }

  .schedule-content {
    display: flex;
    flex: 1;
    min-height: 0;
    border: none;
    box-shadow: none;
    margin-top: 0;

    > .schedule-content-body {
      display: flex;
      flex: 1;
      min-height: 0;
      box-sizing: border-box;
    }
  }

  .view-switch {
    ::v-deep .el-radio-button__inner {
      min-width: 88px;
    }

    i {
      margin-right: 4px;
    }
  }

  .calendar-grid {
    display: grid;
    flex: 1;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    gap: 12px;
    min-height: 0;
    overflow-x: auto;
  }

  .day-card {
    min-height: 0;
    border: 1px solid #dfe7f2;
    border-radius: 8px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
    padding: 12px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    overflow: hidden;
  }

  .day-head {
    color: #334155;
    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 1px solid #edf2f7;

    strong {
      color: #1f2d3d;
      font-size: 17px;
      line-height: 22px;
    }

    span {
      min-width: 28px;
      height: 28px;
      border-radius: 50%;
      background: #eef4ff;
      color: #2f5fb3;
      font-size: 15px;
      font-weight: 600;
      line-height: 28px;
      text-align: center;
    }
  }

  .schedule-list {
    display: grid;
    gap: 10px;
  }

  .schedule-item {
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    border: 1px solid #c9ddff;
    border-left: 3px solid #2f6fec;
    border-radius: 8px;
    background: #f3f8ff;
    padding: 10px;
    color: #1f2d3d;
    cursor: pointer;
    overflow: hidden;
    transition: border-color 0.18s ease, box-shadow 0.18s ease;

    &:hover {
      border-color: #8fb8ff;
      box-shadow: 0 4px 12px rgba(47, 111, 236, 0.1);
    }
  }

  .team-name {
    display: block;
    color: #0f2742;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .shift-name {
    margin-top: 2px;
    color: #315f9f;
    font-size: 13px;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .schedule-time {
    margin-top: 8px;
    color: #223449;
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    i {
      margin-right: 5px;
      color: #5b8def;
    }
  }

  .members {
    margin-top: 6px;
    color: #6b7b8d;
    font-size: 12px;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    i {
      margin-right: 5px;
      color: #8aa0ba;
    }
  }

  .pager {
    text-align: right;
  }

  .schedule-list-view {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    width: 100%;
  }

  .schedule-list-view ::v-deep .el-table {
    flex: 1;
    min-height: 0;
  }

  .schedule-table ::v-deep th.el-table__cell {
    height: 42px;
    padding: 0;
    background-color: #f5f7fa;
    border-right: none;
  }

  .schedule-table ::v-deep td.el-table__cell {
    height: 40px;
    padding: 8px 0;
    border-right: none;
  }

  .schedule-table ::v-deep .el-table__header-wrapper th.el-table__cell,
  .schedule-table ::v-deep .el-table__body-wrapper td.el-table__cell {
    border-right: none;
  }

  .schedule-table ::v-deep .cell {
    line-height: 22px;
  }

  .schedule-table::before,
  .schedule-table::after {
    display: none;
  }

  .table-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    min-height: 22px;
    white-space: nowrap;
  }

  .table-actions ::v-deep .el-button--text.el-button--small {
    flex-shrink: 0;
    height: auto;
    padding: 0;
    line-height: 22px;
  }

  .table-actions ::v-deep .el-button + .el-button {
    margin-left: 0;
  }

  .schedule-pagination {
    flex-shrink: 0;
    padding: 12px 18px 8px;
    border-top: 1px solid #ebeef5;
    text-align: right;
    box-sizing: border-box;
  }

  .shift-toolbar {
    margin-bottom: 10px;
  }
}
</style>
